export default __webpack_public_path__ + "assets/images/aistudio/empty_state/4aa80a3454628df5d55275b8d2d3f43e.png";